import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="admin-sidebar">
      {/* Logo Section */}
      <div className="sidebar-logo">
        <img style={{backgroundColor: 'white', borderRadius: '8px', padding: '3px'}} src="/images/homehive.png" alt="HomeHive Logo" />
      </div>

      {/* Navigation Links */}
      <nav className="sidebar-nav">
        <Link 
          to="/admin/dashboard" 
          className={`nav-link ${isActive('/admin/dashboard') ? 'active' : ''}`}
        >
          <i className="fas fa-chart-line"></i>
          <span>Dashboard</span>
        </Link>

        <Link 
          to="/admin/all-users" 
          className={`nav-link ${isActive('/admin/all-users') ? 'active' : ''}`}
        >
          <i className="fas fa-users"></i>
          <span>All Users</span>
        </Link>

        <Link 
          to="/admin/reviews" 
          className={`nav-link ${isActive('/admin/reviews') ? 'active' : ''}`}
        >
          <i className="fas fa-star"></i>
          <span>Reviews</span>
        </Link>

        <Link 
          to="/admin/properties" 
          className={`nav-link ${isActive('/admin/properties') ? 'active' : ''}`}
        >
          <i className="fas fa-home"></i>
          <span>Properties</span>
        </Link>

        <Link 
          to="/admin/analytics" 
          className={`nav-link ${isActive('/admin/analytics') ? 'active' : ''}`}
        >
          <i className="fas fa-chart-line"></i>
          <span>Analytics</span>
        </Link>

      </nav>

      {/* User Profile Section */}
      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="user-info">
            <Link 
              to='/logout' 
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: 'rgba(255, 255, 255, 0.7)',
                textDecoration: 'none',
                padding: '8px 12px',
                borderRadius: '6px',
                transition: 'all 0.3s ease',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(23, 12, 12, 0.1)';
                e.currentTarget.style.color = 'black';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = 'rgba(237, 222, 222, 0.7)';
              }}
            >
              <i className="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
